import { createSelector } from "reselect";

export const tenantsSelector = createSelector(
    state => state.services.tenants,
    state => state
);